import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Modal } from 'antd';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

import {
    fetchAllProducts,
    fetchAllHighlightProducts,
    fetchHighlightProduct,
    updateHighlightProducts,
    getHighlightProductImage,
    addHighlightProduct
} from '../../actions/Product';

import AddModal from './HighlightProductModal';

const $ = window.$;
class HighlighProducts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            selectedHighlightProduct: null,
            highlightProducts: []
        };
    }

    componentDidMount() {
        // $(function () {
        //     $('[data-toggle="tooltip"]').tooltip();
        // });

        // $(".select-dropdown").on('click', 'li a', function () {
        //     $(".btn.form-list:first-child").text($(this).text());
        //     $(".btn.form-list:first-child").val($(this).text());
        //     $('.btn.form-list:first-child').addClass('selected');
        // });

        this.props.fetchAllHighlightProducts();
        const { products } = this.props;
        if (_.size(products) === 0) {
            this.props.fetchAllProducts();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sortedHighlightProducts) {
            this.setState({ highlightProducts: nextProps.sortedHighlightProducts });
        }
    }

    onAddClick() {
        console.log('show');
        this.setState({ showModal: true, selectedHighlightProduct: null });
    }

    onModalCancel() {
        this.setState({ showModal: false, selectedHighlightProduct: null });
    }

    onModalSubmit(file, productId) {
        // TODO: send data

        const { highlightProducts } = this.state;

        const highlightObject = {
            order: highlightProducts.length,
            product_id: productId
        }

        this.props.addHighlightProduct(highlightObject, file, () => {
            // done
        });
    }

    onEditClick(highlightProduct) {

        console.log(highlightProduct);

        this.setState({
            showModal: true,
            selectedHighlightProduct: highlightProduct
        });
    }

    onDeleteClick(highlightProduct) {

    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        console.log(`old: ${oldIndex}, new: ${newIndex}`);

        // console.log(this.state.highlightProducts);
        const newArray = arrayMove(this.state.highlightProducts, oldIndex, newIndex);

        this.setState({
            highlightProducts: newArray,
        }, () => {
            console.log(this.state.highlightProducts);
            this.props.updateHighlightProducts(newArray);
        });
    }

    renderImage(highlight) {
        const { highlightProductImages } = this.props;
        if (highlightProductImages[highlight.highlightId]) {
            return <img src={highlightProductImages[highlight.highlightId]} alt="Product" />
        }
        this.props.getHighlightProductImage(highlight.highlightId, highlight.image_name);
    }

    renderProducts() {
        const { products } = this.props;
        const { highlightProducts } = this.state;

        const highlightProductViews = highlightProducts.map((highlight, index) => {

            const product = products[highlight.product_id];

            return (
                <HighlightItem className="dragable-order" key={highlight.highlightId} index={index}>
                    {/* <div className="order"> */}
                        <div className="row">
                            <div className="col-md-auto">
                                <label>{`Order ${index + 1}`}</label>
                            </div>
                            <div className="col-md-auto product-img">
                                {highlight ? this.renderImage(highlight) : null}
                            </div>
                            <div className="col">
                            <label>{product ? product.name_en : ''}</label>
                            </div>
                            <div className="col-md-auto">
                                <button
                                    type="button"
                                    className="btn btn-tooltip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Edit"
                                    onClick={() => this.onEditClick(highlight)}
                                >
                                    <img src="/resources/img/ic-edit.png" alt="edit" />
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-tooltip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Delete"
                                    onClick={() => this.onDeleteClick(highlight)}
                                >
                                    <img src="/resources/img/ic-delete.png" alt="delete" />
                                </button>
                            </div>
                        {/* </div> */}
                    </div>
                </HighlightItem>
            );
        });

        return (
            <HighlightList
                pressDelay={200}
                onSortEnd={this.onSortEnd.bind(this)}
            >
                <div className="order-list">{highlightProductViews}</div>
            </HighlightList>
        );
    }

    render() {
        const { showModal, selectedHighlightProduct, highlightProducts } = this.state;
        const { products } = this.props;

        return (
            <div className="main-content">
                <div className="page-title">Highlight Products</div>
                <div className="divider"></div>
                {this.renderProducts()}
                <div className="form-group add-more-btn" onClick={this.onAddClick.bind(this)} data-toggle="modal">
                    <img src="/resources/img/ic-add.png" alt="" />
                    <label>Add Highlight Product</label>
                </div>
                <Modal
                    visible={showModal}
                    closable={false}
                    footer={null}
                >
                    <AddModal
                        onCancel={this.onModalCancel.bind(this)}
                        onAdd={this.onModalSubmit.bind(this)}
                        highlightProduct={selectedHighlightProduct}
                        products={products}
                    />
                </Modal>
            </div>
        )
    }
}

const HighlightList = SortableContainer((props) => {
    const { children } = props;
    return <div>{children}</div>
});

const HighlightItem = SortableElement((props) => {
    const { children, className } = props;
    return <div className={className}>{children}</div>
});

function mapStateToProps(state) {
    const {
        highlightProducts,
        isHighlightLoading,
        isHighlightError,
        highlightError,
        sortedHighlightProducts,
        products,
        highlightProductImages
    } = state.product;
    return {
        highlightProducts,
        isHighlightLoading,
        isHighlightError,
        highlightError,
        sortedHighlightProducts,
        products,
        highlightProductImages
    };
}

export default connect(mapStateToProps, {
    fetchAllHighlightProducts,
    fetchHighlightProduct,
    fetchAllProducts,
    updateHighlightProducts,
    getHighlightProductImage,
    addHighlightProduct
})(HighlighProducts);



// WEBPACK FOOTER //
// ./src/views/products/HighlightProducts.js